import { createClient } from '@supabase/supabase-js';
const supabaseClient = createClient(
  'https://rhswxmfekzxxsmojqwlb.supabase.co',
  'sb_publishable_T6D0ITEMOk2skayTTAYmIw_xAL1-IPL'
);
export default supabaseClient;
